import React, { Component, Fragment, Text } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Button,
  Label,
  Header,
  Tab,
  Dropdown,
  Radio,  
} from 'semantic-ui-react';
import _, { set } from 'lodash';
import PropTypes from 'prop-types';
import { settingsActions } from '../../actions/settings.actions';
import { ImportScreen } from './import';
import moment from 'moment';
import { userActions } from '../../actions/user.actions';
import { WebhookIndexScreen } from './webhook-index';
import settingsService from '../../services/settings.service';
import { userConstants } from '../../constants/user.constants';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

class GlobalSettingsEditScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      settings: {
        delegationEnabled: false,
        clockRegisterBlockMode: 2,
        clockRegisterInputMode: 1,
        clockRegisterAddLunch: false,
        strictClockControl: false,
        clockRegisterExtraTime: 0,
        clockRegisterWorkMinutes: 0,
        clockRegisterQuotaMinutes: 0,
        clockRegisterQuotaMode: false,
        lunchRegisterBlockMode: 2,
        lunchRegisterBlockTime: 0,
        primaryColor: '',
        secondaryColor: '',
        lunchAction: 0,
        fixedLunchTime: false,
        protectedAccountMode: 0,
        allowImmediateSuperiorApproval: false,
        allowMediateSuperiorApproval: false,
        marginMinutesRequestBlock: 0,
        expirationAction: 0,        
        maxMinutesRequest: 120,
        maxRequestsPerDay: 1,
        approveRequestUserLockMode: 1,
        ahgoraIntegrationEnabled: false,
        ahgoraToken: '',
        forPontoIntegrationEnabled: false,
        forPontoConnectionString: '',
        forPontoTableName: 'PPilFpto',
        databaseIntegrationEnabled: false,
        databaseAutoCreateUser: false,
        databaseConnectionString: '',
        databaseTableUser: '',
        databaseTableClock: '',
        databaseToleranceEntry: 0,
        databaseToleranceExit: 0,
        norberIntegrationEnabled: false,
        norberUsername: '',
        norberPassword: '',
        norberBaseUrl: '',
        activeDirectoryLogonHoursEnabled: false,
        allowGroupApproval: true,
        sendGroupApprovalEmail: false,
        tivitIntegrationEnabled: false,
        tivitTenantId: '',
        tivitClientId: '',
        tivitClientSecret: '',
        tivitApiBaseUrl: '',
        agentVersionGlobal: '1.7.1',
      },
      sessionTypes: [],
      requestTypes: [],
      clockRegisterEventTypes: [],
      errors: {},
      removeFile: false,
      file: null,
      submitted: false
    };
  }

  componentDidMount() {
    this.loadSettings();
  }

  toggleSessionType(sessionType) {
    let { sessionTypes } = this.state;
    if (sessionTypes.includes(sessionType)) {      
      sessionTypes = sessionTypes.filter(type => type !== sessionType);      
    } else {
      sessionTypes.push(sessionType);
    }
    this.setState({ sessionTypes });
  }

  toggleRequestType(requestType) {
    let { requestTypes } = this.state;
    if (requestTypes.includes(requestType)) {      
      requestTypes = requestTypes.filter(type => type !== requestType);      
    } else {
      requestTypes.push(requestType);
    }
    this.setState({ requestTypes });
  }

  toggleClockRegisterEventType(eventType) {
    let { clockRegisterEventTypes } = this.state;    
    if (clockRegisterEventTypes.includes(eventType)) {      
      clockRegisterEventTypes = clockRegisterEventTypes.filter(type => type !== eventType);      
    } else {
      clockRegisterEventTypes.push(eventType);
    }
    this.setState({ clockRegisterEventTypes });
  }

  loadSettings() {
    const { dispatch } = this.props;
    dispatch(settingsActions.fetchGlobal())
            .then(() => {
                const settings = _.mapKeys(this.props.settings, function (v, k) { return k[0].toLowerCase() + k.substr(1); });
                const sessionTypes = settings.sessionTypes?.split(',').filter(type => type !== 'Network') || [];
                const clockRegisterEventTypes = settings.clockRegisterEventTypes?.split(',') || [];
                const requestTypes = settings.allowedRequestTypes?.split(',') || [];
                if (!settings.primaryColor) {
                  settings.primaryColor = '#004867';
                }
                if (!settings.secondaryColor) {
                  settings.secondaryColor = '#ff5958';
                }
                this.setState({ settings, sessionTypes, clockRegisterEventTypes, requestTypes })
            });
  }

  static get propTypes() {
    return {
        settings: PropTypes.any,
        loading: PropTypes.bool,
        loadingSync: PropTypes.any,
    };
  }

  handleChange(field, data) {
    const { settings } = this.state;
    settings[field] = data;    
    this.setState({ settings });
  }

  onChangeFile(e) {          
    this.setState({ file: e.target.files[0]});
  }

  onChangeRemoveFile(value) {              
    this.setState({ removeFile: value});
  }

  async handleSubmit(reloadPage) {
    const { dispatch } = this.props;
    const { settings, sessionTypes, requestTypes, clockRegisterEventTypes, file, removeFile } = this.state;        
    
    if (file) {
      const uploaded = await settingsService.uploadFile(file);
      if (uploaded && uploaded.id) {
        settings.imageId = uploaded.id;
      }
    } 
        
    if (removeFile) {
      settings.imageId = null;
    }
    
    settings.sessionTypes = sessionTypes.join(',');
    settings.allowedRequestTypes = requestTypes.join(',');
    settings.clockRegisterEventTypes = clockRegisterEventTypes.join(',');
    dispatch(settingsActions.updateGlobal(settings)).then(() => {
      if (reloadPage) {
        document.location.reload();
      }
    });
  }

  syncAhgoraClock() {    
    if (confirm('Sincronizar os registros de ponto?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncAhgoraClock());
    }
  }

  unlockAll() {
    if (confirm('Desbloquear todos os usuários?')) {
      const { dispatch } = this.props;
      dispatch(userActions.unblockAll());
    }
  }
  
  syncAhgoraUsers() {
    if (confirm('Sincronizar os cadastros de usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncAhgoraUsers());
    }
  }

  syncApDataClock() {    
    if (confirm('Sincronizar os registros de ponto?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncApDataClock());
    }
  }

  syncApDataUsers() {
    if (confirm('Sincronizar os cadastros de usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncApDataUsers());
    }
  }

  syncSinergyClock() {    
    if (confirm('Sincronizar os registros de ponto?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncSinergyClock());
    }
  }

  syncSinergyUsers() {
    if (confirm('Sincronizar os cadastros de usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncSinergyUsers());
    }
  }

  syncTivitClock() {
    if (confirm('Sincronizar os registros de ponto?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncTivitClock());
    }
  }

  syncTivitUsers() {
    if (confirm('Sincronizar os cadastros de usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncTivitUsers());
    }
  }

  syncBemClock() {
    if (confirm('Sincronizar os registros de ponto?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncBemClock());
    }
  }

  syncBemUsers() {
    if (confirm('Sincronizar os cadastros de usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncBemUsers());
    }
  }

  syncFolhaCertaClock() {
    if (confirm('Sincronizar os registros de ponto?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncFolhaCertaClock());
    }
  }

  syncPontoTelUsers() {
    if (confirm('Sincronizar os cadastros de usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncPontoTelUsers());
    }
  }

    syncPontoTelClock() {
    if (confirm('Sincronizar os registros de ponto?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncPontoTelClock());
    }
  }

  syncFolhaCertaUsers() {
    if (confirm('Sincronizar os cadastros de usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncFolhaCertaUsers());
    }
  }

  syncSeniorUsers() {
    if (confirm('Sincronizar os cadastros de usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncSeniorUsers());
    }
  }

  syncAdpUsers() {
    if (confirm('Sincronizar os cadastros de usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncAdpUsers());
    }
  }

   syncAdpClock() {
    if (confirm('Sincronizar os registros de ponto?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncAdpClock());
    }
  }

  syncNorberUsers() {
    if (confirm('Sincronizar os cadastros de usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncNorberUsers());
    }
  }

  syncProtectedAccounts() {
    if (confirm('Sincronizar as contas protegidas do UserLock?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncAccounts());
    }
  }

  expireRequests() {
    if (confirm('Expirar todas as solicitações com data de início menor do que a atual?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.expireRequests());
    }
  }

  removeExpired() {
    if (confirm('Remover todas as contas temporárias expiradas?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.removeExpired());
    }
  }

  testForPontoConnection() {
    const { dispatch } = this.props;
    dispatch(settingsActions.testForPontoConnection());
  }

  syncForPontoClock() {
    if (confirm('Sincronizar os registros de ponto?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncForPontoClock());
    }
  }

  syncForPontoUsers() {
    if (confirm('Sincronizar os cadastros de usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncForPontoUsers());
    }
  }

  testDatabaseConnection() {
    const { dispatch } = this.props;
    dispatch(settingsActions.testDatabaseConnection());
  }

  syncDatabaseClock() {
    if (confirm('Sincronizar os registros de ponto?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncDatabaseClock());
    }
  }

  syncDatabaseUsers() {
    if (confirm('Sincronizar os cadastros de usuários?')) {
      const { dispatch } = this.props;
      dispatch(settingsActions.syncDatabaseUsers());
    }
  }

  testAzureAdAuth() {
    const { dispatch } = this.props;    
    dispatch(settingsActions.testAzureAdAuth());
  }

  createAzureAdPolicyAndGroup() {
    if (!confirm('Isto irá criar um novo grupo e política condicional no Azure AD. Deseja continuar?')) {
      return;
    }
    
    const { dispatch } = this.props;
    dispatch(settingsActions.createAzureAdPolicyAndGroup()).then(() => this.loadSettings());
  }

  syncAzureAdUsers() {
    if (!confirm('Isto irá colocar os usuários com bloqueio no grupo de acesso condicional. Continuar?')) {
      return;
    }
    
    const { dispatch } = this.props;
    dispatch(settingsActions.syncAzureAdUsers()).then(() => this.loadSettings());
  }

  updateLicense() {
    const { dispatch } = this.props;
    const { settings } = this.state;
    dispatch(settingsActions.updateLicense(settings.newLicense)).then(() => {
      this.loadSettings();
    });
  }

  render() {  
    const { settings, errors, sessionTypes, requestTypes, clockRegisterEventTypes, removeFile } = this.state;
    const { me } = this.props;
    var terms = settings.termsOfUse || "";

    // Check Permission    
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }

    const blockModeOptions = [
        { key: 1, value: 1, text: "Ativado" },
        { key: 2, value: 2, text: "Desativado" },
    ];

    const azureAdBlockModeOptions = [
      { key: 1, value: 1, text: "Todos os Usuários" },
      { key: 2, value: 2, text: "Somente Marcados" },
  ];

    const expirationActionOptions = [
        { key: 0, value: 0, text: "Nenhuma ação" },
        { key: 1, value: 1, text: "Logoff" },
        { key: 2, value: 2, text: "Bloqueio" },
    ];

    const proctectedAccountModeOptions = [
      { key: 0, value: 0, text: "Não Criar" },
      { key: 1, value: 1, text: "Criar com bloqueio de jornada" },
      { key: 2, value: 2, text: "Criar com bloqueio total" }      
    ];

    const inputModeOptions = [
      { key: 1, value: 1, text: "Integração" },
      { key: 2, value: 2, text: "Login" },
      { key: 3, value: 3, text: "Integração e Login" },
      { key: 4, value: 4, text: "Desativado" },
    ];

    const webServiceModeOptions = [
      { key: 0, value: 0, text: "SOAP" },
      { key: 1, value: 1, text: "REST" },      
    ];

    const agentVersionOptions = [
      { key: 0, value: "1.7.0", text: "1.7.0.0" },
      { key: 1, value: "1.7.1", text: "1.7.1.0" },      
      { key: 2, value: "1.7.2.0", text: "1.7.2.0" },      
      { key: 3, value: "1.7.3.0", text: "1.7.3.0" },      
      { key: 4, value: "1.7.4.0", text: "1.7.4.0" },      
      { key: 4, value: "1.7.5.0", text: "1.7.5.0" },      
    ];

    const syncButtonStyle = { marginLeft: 16, marginTop: -4 };

    const tabSettings = (
      <Fragment>
        <Form loading={this.props.loading} onSubmit={() => this.handleSubmit()}>
          <h3>Geral</h3>
          <Form.Input required error={errors.portalUrl} label='URL Portal' value={settings.portalUrl} name='portalUrl' type='text' onChange={(e, data) => this.handleChange("portalUrl", data.value)} />
          { errors.portalUrl && <Label color='red'>{errors.portalUrl}</Label>}

          <Form.Field required>
            <label>Modo de Criação de Conta Protegida</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              selection
              onChange={(e, data) => this.handleChange("protectedAccountMode", data.value)}
              options={proctectedAccountModeOptions}
              value={settings.protectedAccountMode}
            />
            { errors.protectedAccountMode && <Label basic pointing  color='red'>{errors.protectedAccountMode}</Label>}
          </Form.Field>

          <Form.Input>
            <Radio toggle checked={settings.autoCreateProtectedAccount} label='Criar contas protegidas automaticamente' onChange={(e, data) => this.handleChange("autoCreateProtectedAccount", data.checked)} />            
            <Button 
              onClick={() => this.syncProtectedAccounts()} 
              icon='refresh' 
              type='button' 
              size='mini' 
              title='Sincronizar contas agora'               
              circular              
              loading={this.props.loadingSync === 'accounts'}
              disabled={!settings.autoCreateProtectedAccount}
              style={syncButtonStyle} />       
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.fullBlockInactiveUsers} label='Bloquear usuários inativos' onChange={(e, data) => this.handleChange("fullBlockInactiveUsers", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.autoSyncUserUpdate} label='Atualizar conta protegida ao alterar usuário' onChange={(e, data) => this.handleChange("autoSyncUserUpdate", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.autoRemoveExpiredTemporaryProtectedAccounts} label='Limpar contas temporárias expiradas' onChange={(e, data) => this.handleChange("autoRemoveExpiredTemporaryProtectedAccounts", data.checked)} />                 
            <Button 
              onClick={() => this.removeExpired()} 
              icon='refresh' 
              type='button' 
              size='mini' 
              title='Limpar contas expiradas agora'               
              circular              
              loading={this.props.loadingSync === 'removeExpired'}
              disabled={!settings.autoRemoveExpiredTemporaryProtectedAccounts}
              style={syncButtonStyle} />       
          </Form.Input>

          <Form.Input required error={errors.clockRegisterWorkMinutes} label='Tempo padrão da jornada (minutos)' value={settings.clockRegisterWorkMinutes} name='clockRegisterWorkMinutes' type='number' onChange={(e, data) => this.handleChange("clockRegisterWorkMinutes", data.value)} />
          { errors.clockRegisterWorkMinutes && <Label color='red'>{errors.clockRegisterWorkMinutes}</Label>}

          <Form.Input required error={errors.logoffNotificationTimeout} label='Tempo Notificação Logoff (minutos, 0 para desabilitar)' value={settings.logoffNotificationTimeout} name='logoffNotificationTimeout' type='number' onChange={(e, data) => this.handleChange("logoffNotificationTimeout", data.value)} />
          { errors.logoffNotificationTimeout && <Label color='red'>{errors.logoffNotificationTimeout}</Label>}

          <Form.Input>
            <Radio toggle checked={settings.onlyNotifyClockedUsers} label='Enviar notificações somente para usuários com registro de ponto' onChange={(e, data) => this.handleChange("onlyNotifyClockedUsers", data.checked)} />
          </Form.Input>

          <Form.Input required error={errors.clockRegisterMinInterval} label='Intervalo mínimo para registro de ponto (minutos)' value={settings.clockRegisterMinInterval} name='clockRegisterMinInterval' type='number' onChange={(e, data) => this.handleChange("clockRegisterMinInterval", data.value)} />
          { errors.clockRegisterMinInterval && <Label color='red'>{errors.clockRegisterMinInterval}</Label>}

          <h3>Bloqueio de Registro de Ponto</h3>
          <Form.Field required>
            <label>Controle de Bloqueio de Ponto</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              selection
              onChange={(e, data) => this.handleChange("clockRegisterBlockMode", data.value)}
              options={blockModeOptions}
              value={settings.clockRegisterBlockMode}
            />
            { errors.clockRegisterBlockMode && <Label basic pointing  color='red'>{errors.clockRegisterBlockMode}</Label>}
          </Form.Field>

          <Form.Field required>
            <label>Entrada de Registro de Ponto</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              selection
              onChange={(e, data) => this.handleChange("clockRegisterInputMode", data.value)}
              options={inputModeOptions}
              value={settings.clockRegisterInputMode}
            />
            { errors.clockRegisterInputMode && <Label basic pointing  color='red'>{errors.clockRegisterInputMode}</Label>}
          </Form.Field>

          <Form.Field>
            <label>Eventos de Entrada Registro de Ponto</label>
            <Form.Checkbox label='Logoff' checked={clockRegisterEventTypes.includes('0')} onChange={() => this.toggleClockRegisterEventType('0')} />
            <Form.Checkbox label='Logon' checked={clockRegisterEventTypes.includes('1')} onChange={() => this.toggleClockRegisterEventType('1')} />
            <Form.Checkbox label='Bloqueio' checked={clockRegisterEventTypes.includes('2')} onChange={() => this.toggleClockRegisterEventType('2')} />
            <Form.Checkbox label='Desbloqueio' checked={clockRegisterEventTypes.includes('3')} onChange={() => this.toggleClockRegisterEventType('3')} />            
          </Form.Field>

          <Form.Input error={errors.workJourneyLimit} label='Horário Limite de Jornada' value={settings.workJourneyLimit} name='workJourneyLimit' type='text' onChange={(e, data) => this.handleChange("workJourneyLimit", data.value)} />
          { errors.workJourneyLimit && <Label color='red'>{errors.workJourneyLimit}</Label>}
          <Label>Se definido, nenhum usuário sem solicitação poderá ficar conectado após este horário, independente do horário de entrada</Label>

          <Form.Input>
            <Radio toggle checked={settings.globalBlockDisable} label='Desativar Bloqueio Agente CtrlStation' onChange={(e, data) => this.handleChange("globalBlockDisable", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.globalNotificationDisable} label='Desativar Envio de Notificações' onChange={(e, data) => this.handleChange("globalNotificationDisable", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.validateAgentToken} label='Validar Token Agente CtrlStation' onChange={(e, data) => this.handleChange("validateAgentToken", data.checked)} />
          </Form.Input>
          
          <Form.Input>
            <Radio toggle checked={settings.clockRegisterFullTempAccount} label='Utilizar conta temporária de dia inteiro' onChange={(e, data) => this.handleChange("clockRegisterFullTempAccount", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.clockRegisterAddLunch} label='Somar horário de almoço' onChange={(e, data) => this.handleChange("clockRegisterAddLunch", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.clockRegisterAddTolerance} label='Somar tolerância de saída' onChange={(e, data) => this.handleChange("clockRegisterAddTolerance", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.strictClockControl} label='Controle Estrito de Entrada' onChange={(e, data) => this.handleChange("strictClockControl", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.strictClockControlFinish} label='Controle Estrito de Saída' onChange={(e, data) => this.handleChange("strictClockControlFinish", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.clockRegisterQuotaMode} label='Modo Quota de Controle de Ponto' onChange={(e, data) => this.handleChange("clockRegisterQuotaMode", data.checked)} />
          </Form.Input>
        
          <Form.Input>
            <Radio toggle checked={settings.limitFlexibleJourney} label='Limitar horário de saída à jornada padrão' onChange={(e, data) => this.handleChange("limitFlexibleJourney", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.disableClockRegisterUnblocked} label='Ignorar registro de ponto de usuários desbloqueados' onChange={(e, data) => this.handleChange("disableClockRegisterUnblocked", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.disableBlockUsersUnblocked} label='Não reativar bloqueio de usuários desbloqueados no dia seguinte' onChange={(e, data) => this.handleChange("disableBlockUsersUnblocked", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.allowUserCheckStatus} label='Exibir jornada atual do usuário na tela inicial' onChange={(e, data) => this.handleChange("allowUserCheckStatus", data.checked)} />
          </Form.Input>

          <Button onClick={() => this.unlockAll()} 
            type='button' 
            content='Desbloquear Todos os Usuários'            
            loading={this.props.loadingSync === 'unblockAll'}
            icon='unlock' />

          <Form.Input required error={errors.interJourneyInterval} label='Intervalo Mínimo Entre Jornada (minutos)' value={settings.interJourneyInterval} name='interJourneyInterval' type='number' onChange={(e, data) => this.handleChange("interJourneyInterval", data.value)} />
          { errors.interJourneyInterval && <Label color='red'>{errors.interJourneyInterval}</Label>}

          <Form.Input required error={errors.clockRegisterExtraTime} label='Tempo Adicional à jornada (minutos)' value={settings.clockRegisterExtraTime} name='clockRegisterExtraTime' type='number' onChange={(e, data) => this.handleChange("clockRegisterExtraTime", data.value)} />
          { errors.clockRegisterExtraTime && <Label color='red'>{errors.clockRegisterExtraTime}</Label>}

          <Form.Field required>
            <label>Ação de Bloqueio ao Término da Jornada</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              selection
              onChange={(e, data) => this.handleChange("expirationAction", data.value)}
              options={expirationActionOptions}
              value={settings.expirationAction}
            />
            { errors.expirationAction && <Label basic pointing  color='red'>{errors.expirationAction}</Label>}
          </Form.Field>

          <Form.Field>
            <label>Tipos de Sessão a Bloquear</label>
            <Form.Checkbox label='Todas' checked={sessionTypes.includes('All')} onChange={() => this.toggleSessionType('All')} />
            <Form.Checkbox label='Workstation' checked={sessionTypes.includes('Workstation')} onChange={() => this.toggleSessionType('Workstation')} />
            <Form.Checkbox label='Terminal' checked={sessionTypes.includes('Terminal')} onChange={() => this.toggleSessionType('Terminal')} />
            <Form.Checkbox label='Interativa' checked={sessionTypes.includes('Interactive')} onChange={() => this.toggleSessionType('Interactive')} />
            <Form.Checkbox label='IIS' checked={sessionTypes.includes('IIS')} onChange={() => this.toggleSessionType('IIS')} />
            <Form.Checkbox label='RAS' checked={sessionTypes.includes('RAS')} onChange={() => this.toggleSessionType('RAS')} />            
            <Form.Checkbox label='VPN' checked={sessionTypes.includes('VPN')} onChange={() => this.toggleSessionType('VPN')} />
            <Form.Checkbox label='WiFi' checked={sessionTypes.includes('Wifi')} onChange={() => this.toggleSessionType('Wifi')} />
            <Form.Checkbox label='SaaS' checked={sessionTypes.includes('SAAS')} onChange={() => this.toggleSessionType('SAAS')} />
          </Form.Field>

          <h3>Bloqueio de Almoço</h3>
          <Form.Field required>
            <label>Bloqueio de Ponto de Almoço</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              selection
              onChange={(e, data) => this.handleChange("lunchRegisterBlockMode", data.value)}
              options={blockModeOptions}
              value={settings.lunchRegisterBlockMode}
            />
            { errors.lunchRegisterBlockMode && <Label basic pointing  color='red'>{errors.lunchRegisterBlockMode}</Label>}
          </Form.Field>

          <Form.Field required>
            <label>Ação de Bloqueio de Almoço</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              selection
              onChange={(e, data) => this.handleChange("lunchAction", data.value)}
              options={expirationActionOptions}
              value={settings.lunchAction}
            />
            { errors.lunchAction && <Label basic pointing  color='red'>{errors.lunchAction}</Label>}
          </Form.Field>

          <Form.Input required error={errors.lunchRegisterBlockTime} label='Tempo Padrão de Bloqueio de Almoço (minutos)' value={settings.lunchRegisterBlockTime} name='lunchRegisterBlockTime' type='number' onChange={(e, data) => this.handleChange("lunchRegisterBlockTime", data.value)} />
          { errors.lunchRegisterBlockTime && <Label color='red'>{errors.lunchRegisterBlockTime}</Label>}

          <Form.Input>
            <Radio toggle checked={settings.strictClockControlLunch} label='Controle Estrito de Almoço' onChange={(e, data) => this.handleChange("strictClockControlLunch", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.fixedLunchTime} label='Tempo Fixo de Almoço' onChange={(e, data) => this.handleChange("fixedLunchTime", data.checked)} />
          </Form.Input>

          <h3>Solicitações de Horas Adicionais</h3>
          <Form.Input>
            <Radio toggle checked={settings.allowImmediateSuperiorApproval} label='Permitir aprovação por superior imediato' onChange={(e, data) => this.handleChange("allowImmediateSuperiorApproval", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.allowMediateSuperiorApproval} label='Permitir aprovação por superior mediato' onChange={(e, data) => this.handleChange("allowMediateSuperiorApproval", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.allowGroupApproval} label='Permitir aprovação por aprovadores de grupos' onChange={(e, data) => this.handleChange("allowGroupApproval", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.sendGroupApprovalEmail} label='Enviar e-mail para aprovadores de grupos' onChange={(e, data) => this.handleChange("sendGroupApprovalEmail", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.sendEmailApproverRole} label='Enviar e-mail para usuários com perfil "Aprovador"' onChange={(e, data) => this.handleChange("sendEmailApproverRole", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.allowBatchApproval} label='Habilitar Botão "Aprovar Pendentes"' onChange={(e, data) => this.handleChange("allowBatchApproval", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.requireCommentOnReject} label='Solicitar comentário ao rejeitar' onChange={(e, data) => this.handleChange("requireCommentOnReject", data.checked)} />
          </Form.Input>                  

          <Form.Input>
            <Radio toggle checked={settings.allowOverrideMaxMinutesManager} label='Permitir gestor/administrador especificar qualquer quantidade de horas' onChange={(e, data) => this.handleChange("allowOverrideMaxMinutesManager", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.allowManagerUnblockUser} label='Permitir gestor desbloquear usuários subordinados' onChange={(e, data) => this.handleChange("allowManagerUnblockUser", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.allowManagerAccessLogs} label='Permitir gestor visualizar logs de acesso' onChange={(e, data) => this.handleChange("allowManagerAccessLogs", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.delegationEnabled} label='Habilitar Delegações de Aprovação para Gestor' onChange={(e, data) => this.handleChange("delegationEnabled", data.checked)} />
          </Form.Input>    
        
          <Form.Input>
            <Radio toggle checked={settings.allowChooseApprovers} label='Permitir escolher aprovadores' onChange={(e, data) => this.handleChange("allowChooseApprovers", data.checked)} />
          </Form.Input>    

          <Form.Input>
            <Radio toggle checked={settings.fixedRequestTitles} label='Utilizar títulos de solicitação pré-definidos' onChange={(e, data) => this.handleChange("fixedRequestTitles", data.checked)} />
          </Form.Input>
          <Form.TextArea disabled={!settings.fixedRequestTitles} width={12} rows={5} value={settings.requestTitles} label='Títulos Pré-Definidos (um por linha)' name='requestTitles' onChange={(e, data) => this.handleChange("requestTitles", data.value)} />                  

          <Form.Input>
            <Radio toggle checked={settings.fixedRequestTypes} label='Utilizar categorias de solicitação pré-definidas' onChange={(e, data) => this.handleChange("fixedRequestTypes", data.checked)} />
          </Form.Input>
          <Form.TextArea disabled={!settings.fixedRequestTypes} width={12} rows={5} value={settings.requestTypes} label='Categorias de Solicitação (uma por linha)' name='requestTypes' onChange={(e, data) => this.handleChange("requestTypes", data.value)} />                  
          <Form.Input error={errors.autoApproveRequestTypes} label='Categorias com Aprovação Automática (separadas por ,)' value={settings.autoApproveRequestTypes} name='autoApproveRequestTypes' type='text' onChange={(e, data) => this.handleChange("autoApproveRequestTypes", data.value)} />
          { errors.autoApproveRequestTypes && <Label color='red'>{errors.autoApproveRequestTypes}</Label>}

          <Form.Input>
            <Radio toggle checked={settings.fixedRequestProjects} label='Utilizar projeto na solicitação' onChange={(e, data) => this.handleChange("fixedRequestProjects", data.checked)} />
          </Form.Input>
          <Form.TextArea disabled={!settings.fixedRequestProjects} width={12} rows={5} value={settings.requestProjects} label='Projetos (uma por linha)' name='requestProjects' onChange={(e, data) => this.handleChange("requestProjects", data.value)} />                  

          <Form.Input>
            <Radio toggle checked={settings.fixedApprovalCategories} label='Utilizar categorias de aprovação pré-definidas' onChange={(e, data) => this.handleChange("fixedApprovalCategories", data.checked)} />
          </Form.Input>
          <Form.TextArea disabled={!settings.fixedApprovalCategories} width={12} rows={5} value={settings.approvalCategories} label='Categorias de Aprovação (uma por linha)' name='approvalCategories' onChange={(e, data) => this.handleChange("approvalCategories", data.value)} />                  

          <Form.Input>
            <Radio toggle checked={settings.approvalTermEnabled} label='Utilizar termo de ciência de aprovação' onChange={(e, data) => this.handleChange("approvalTermEnabled", data.checked)} />
          </Form.Input>
          
          <Form.TextArea disabled={!settings.approvalTermEnabled} width={12} rows={5} value={settings.approvalTerm} label='Termo de Aprovação' name='approvalTerm' onChange={(e, data) => this.handleChange("approvalTerm", data.value)} />                  
                      
          <Form.Input>
            <Radio toggle checked={settings.autoApprovalTermEnabled} label='Utilizar termo de ciência de auto-aprovação' onChange={(e, data) => this.handleChange("autoApprovalTermEnabled", data.checked)} />
          </Form.Input>
          
          <Form.TextArea disabled={!settings.autoApprovalTermEnabled} width={12} rows={5} value={settings.autoApprovalTerm} label='Termo de Aprovação' name='autoApprovalTerm' onChange={(e, data) => this.handleChange("approvalTerm", data.value)} />                  
           
          
          
          <Form.Input>
            <Radio toggle checked={settings.autoExpireRequests} label='Expirar automaticamente solicitações vencidas' onChange={(e, data) => this.handleChange("autoExpireRequests", data.checked)} />
            <Button 
              onClick={() => this.expireRequests()} 
              icon='refresh' 
              type='button' 
              size='mini'               
              title='Expirar solicitações agora'
              circular
              loading={this.props.loadingSync === 'expireRequests'}
              disabled={!settings.autoExpireRequests}
              style={syncButtonStyle} />              
          </Form.Input>                                  
            
          <Form.Input required error={errors.maxMinutesRequest} label='Tempo Máximo por Solicitação (minutos)' value={settings.maxMinutesRequest} name='maxMinutesRequest' type='number' onChange={(e, data) => this.handleChange("maxMinutesRequest", data.value)} />
          { errors.maxMinutesRequest && <Label color='red'>{errors.maxMinutesRequest}</Label>}

          <Form.Input required error={errors.approvalsRequired} label='Quantidade de Aprovações Necessárias' value={settings.approvalsRequired} name='approvalsRequired' type='number' onChange={(e, data) => this.handleChange("approvalsRequired", data.value)} />
          { errors.approvalsRequired && <Label color='red'>{errors.approvalsRequired}</Label>}

          <Form.Input required error={errors.maxTimeSingleApproval} label='Tempo Máximo para Aprovação Simples (minutos)' value={settings.maxTimeSingleApproval} name='maxTimeSingleApproval' type='number' onChange={(e, data) => this.handleChange("maxTimeSingleApproval", data.value)} />
          { errors.maxTimeSingleApproval && <Label color='red'>{errors.maxTimeSingleApproval}</Label>}

          <Form.Input>
            <Radio toggle checked={settings.requireApprovalWeekend} label='Solicitar Aprovação Múltipla para fim de semana' onChange={(e, data) => this.handleChange("requireApprovalWeekend", data.checked)} />
          </Form.Input>

          <Form.Input required error={errors.maxRequestsPerDay} label='Máximo de Solicitações por Dia' value={settings.maxRequestsPerDay} name='maxRequestsPerDay' type='number' onChange={(e, data) => this.handleChange("maxRequestsPerDay", data.value)} />
          { errors.maxRequestsPerDay && <Label color='red'>{errors.maxRequestsPerDay}</Label>}

          <Form.Input required error={errors.maxRequestsRepeat} label='Máximo de Repetições por Solicitação' value={settings.maxRequestsRepeat} name='maxRequestsRepeat' type='number' onChange={(e, data) => this.handleChange("maxRequestsRepeat", data.value)} />
          { errors.maxRequestsRepeat && <Label color='red'>{errors.maxRequestsRepeat}</Label>}
        
          <Form.Input required error={errors.marginMinutesRequestBlock} label='Margem Regra Desbloqueio (minutos)' value={settings.marginMinutesRequestBlock} name='marginMinutesRequestBlock' type='number' onChange={(e, data) => this.handleChange("marginMinutesRequestBlock", data.value)} />
          { errors.marginMinutesRequestBlock && <Label color='red'>{errors.marginMinutesRequestBlock}</Label>}
         
          <Form.Field>
            <label>Tipos de Solicitação Permitidos</label>
            <Form.Checkbox label='Horas Adicionais' checked={requestTypes.includes('1')} onChange={() => this.toggleRequestType('1')} />
            <Form.Checkbox label='Horário Agendado' checked={requestTypes.includes('0')} onChange={() => this.toggleRequestType('0')} />
            <Form.Checkbox label='Dia Inteiro' checked={requestTypes.includes('2')} onChange={() => this.toggleRequestType('2')} />            
            <Form.Checkbox label='Início de Jornada Antecipada' checked={requestTypes.includes('3')} onChange={() => this.toggleRequestType('3')} />            
            <Form.Checkbox label='Início de Jornada' checked={requestTypes.includes('4')} onChange={() => this.toggleRequestType('4')} />            
          </Form.Field>

          <Form.Input>
            <Radio toggle checked={settings.allowRequestAdditionalTimeWithoutJourney} label='Permitir solicitações de horas adicionais para dias sem jornada' onChange={(e, data) => this.handleChange("allowRequestAdditionalTimeWithoutJourney", data.checked)} />
          </Form.Input>

          <h3>Termos de Uso</h3>

          <ReactQuill 
              theme="snow" 
              value={terms} 
              style={{ height: '100%', width: '80%' }}
              onChange={(value) => this.handleChange('termsOfUse', value)} />
          
          {/* <h3>Agente</h3>
          <Form.Input>
            <Radio toggle checked={settings.agentLocalCache} label='Usar cache local' onChange={(e, data) => this.handleChange("agentLocalCache", data.checked)} />
          </Form.Input> */}

          <div style={{marginTop: '8px'}}>
            <Button primary type='submit'>Salvar</Button>
          </div>    
        </Form>
      </Fragment>
    );
    
    const tabOpenId = (
      <Fragment>
        <Form loading={this.props.loading} onSubmit={() => this.handleSubmit()}>
          <h3>OpenID Connect</h3>
          <Form.Input>
            <Radio toggle checked={settings.openIdEnabled} label='Habilitar Autenticação OpenID' onChange={(e, data) => this.handleChange("openIdEnabled", data.checked)} />
          </Form.Input>

          <Form.Input error={errors.openIdAuthority} label='Autoridade' value={settings.openIdAuthority} name='openIdAuthority' type='text' onChange={(e, data) => this.handleChange("openIdAuthority", data.value)} />
          { errors.openIdAuthority && <Label color='red'>{errors.openIdAuthority}</Label>}
          <Label>Para Azure AD use: https://login.microsoftonline.com/[tenantId]/v2.0</Label>

          <Form.Input error={errors.openIdClientId} label='Client ID' value={settings.openIdClientId} name='openIdClientId' type='text' onChange={(e, data) => this.handleChange("openIdClientId", data.value)} />
          { errors.openIdClientId && <Label color='red'>{errors.openIdClientId}</Label>}

          <Form.Input error={errors.openIdClientSecret} label='Client Secret' value={settings.openIdClientSecret} name='openIdClientSecret' type='text' onChange={(e, data) => this.handleChange("openIdClientSecret", data.value)} />
          { errors.openIdClientSecret && <Label color='red'>{errors.openIdClientSecret}</Label>}

          <Form.Input error={errors.openIdBaseDomain} label='URL Base Retorno' value={settings.openIdBaseDomain} name='openIdBaseDomain' type='text' onChange={(e, data) => this.handleChange("openIdBaseDomain", data.value)} />
          { errors.openIdBaseDomain && <Label color='red'>{errors.openIdBaseDomain}</Label>}

          <Form.Input>
            <Radio toggle checked={settings.openIdAutoLogin} label='Direcionar Automaticamente para Login Office365' onChange={(e, data) => this.handleChange("openIdAutoLogin", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.openIdUsePortalUrl} label='Utilizar URL Portal para Direcionamento' onChange={(e, data) => this.handleChange("openIdUsePortalUrl", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.disableLocalLogin} label='Desativar Login Local' onChange={(e, data) => this.handleChange("disableLocalLogin", data.checked)} />
          </Form.Input>

          <h3>SCIM</h3>
          <Form.Input>
            <Radio toggle checked={settings.scimEnabled} label='Habilitar SCIM' onChange={(e, data) => this.handleChange("scimEnabled", data.checked)} />
          </Form.Input>

          <p><b>URL Endpoint:</b> {settings.apiUrl}/scim</p>

          {settings.scimEnabled && settings.scimToken && <p><b>Token:</b> 
          <textarea readOnly rows="3">{settings.scimToken}</textarea></p>}

          <div style={{marginTop: '8px'}}>
            <Button primary type='submit'>Salvar</Button>
          </div>  
        </Form>
      </Fragment>
    );

    const tabVisual = (
      <Fragment>
        <Form loading={this.props.loading} onSubmit={() => this.handleSubmit(true)} autoComplete="off">
          <h3>Cores</h3>
          <Form.Input error={errors.primaryColor} label='Cor Primária' autocomplete="disable" value={settings.primaryColor} name='primaryColor' type='text' onChange={(e, data) => this.handleChange("primaryColor", data.value)} />
          { errors.primaryColor && <Label color='red'>{errors.primaryColor}</Label>}
          <Form.Input error={errors.secondaryColor} label='Cor Secundária' value={settings.secondaryColor} name='secondaryColor' type='text' onChange={(e, data) => this.handleChange("secondaryColor", data.value)} />
          { errors.secondaryColor && <Label color='red'>{errors.secondaryColor}</Label>}
          <h3>Logotipo</h3>
          {settings.imageId ? <img src={`/api/file/data/${settings.imageId}`} /> : null}
          <Form.Input error={errors.image} value={settings.image} name='file' type='file' onChange={(e) => this.onChangeFile(e)} />
          { errors.image && <Label color='red'>{errors.image}</Label>}
          <Form.Checkbox label='Remover logotipo' checked={removeFile} onChange={(e, data) => this.onChangeRemoveFile(data.checked)} />

          <div style={{marginTop: '8px'}}>
            <Button primary type='submit'>Salvar</Button>
          </div>    
        </Form>
      </Fragment>);

  const tabAgent = (
    <Fragment>
      <Form loading={this.props.loading} onSubmit={() => this.handleSubmit(false)}>
        <h3>Atualização Agentes</h3>
        <Form.Field required>
          <label>Versão Global</label>
          <Dropdown            
            placeholder='Selecione'
            fluid
            selection
            onChange={(e, data) => this.handleChange("agentVersionGlobal", data.value)}
            options={agentVersionOptions}
            value={settings.agentVersionGlobal}
          />
          { errors.agentVersionGlobal && <Label basic pointing  color='red'>{errors.agentVersionGlobal}</Label>}
        </Form.Field>
        <Label>Esta é a versão do agente que as máquinas utilizam. Agentes à partir da versão 1.7.0 atualizarão automáticamente para esta versão.</Label>
        
        <h3>Pré-Atualização Agentes</h3>
        <Form.Field required>
          <label>Versão Pré Atualização</label>
          <Dropdown            
            placeholder='Selecione'
            fluid
            selection
            onChange={(e, data) => this.handleChange("agentVersionTest", data.value)}
            options={agentVersionOptions}
            value={settings.agentVersionTest}
          />
          { errors.agentVersionTest && <Label basic pointing  color='red'>{errors.agentVersionTest}</Label>}
        </Form.Field>
        <Label>Esta versão será somente disponibilizada para os agentes das máquinas especificadas abaixo</Label>

        <Form.Input error={errors.agentTestHostnames} label='Hostnames para Pré Atualização (separados por ,)' value={settings.agentTestHostnames} name='agentTestHostnames' type='text' onChange={(e, data) => this.handleChange("agentTestHostnames", data.value)} />
          { errors.agentTestHostnames && <Label color='red'>{errors.agentTestHostnames}</Label>}

        <div style={{marginTop: '8px'}}>
          <Button primary type='submit'>Atualizar</Button>
        </div>    
      </Form>
    </Fragment>);

    const tabIntegration = (
      <Fragment>
        <Form loading={this.props.loading} onSubmit={() => this.handleSubmit()}>
          <h3>Geral</h3>
          <Form.Input>
            <Radio toggle checked={settings.integrationsAutoCreateUser} label='Integrações devem criar usuários automaticamente' onChange={(e, data) => this.handleChange("integrationsAutoCreateUser", data.checked)} />
          </Form.Input>

          <h3>Integração Ahgora PontoWEB</h3>
          <Form.Input>
            <Radio toggle checked={settings.ahgoraIntegrationEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("ahgoraIntegrationEnabled", data.checked)} />
          </Form.Input>

          <Form.Input disabled={!settings.ahgoraIntegrationEnabled} error={errors.ahgoraToken} label='Token de Acesso (empresa)' value={settings.ahgoraToken} name='ahgoraToken' type='text' onChange={(e, data) => this.handleChange("ahgoraToken", data.value)} />
          { errors.ahgoraToken && <Label color='red'>{errors.ahgoraToken}</Label>}

          <Button onClick={() => this.syncAhgoraUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.ahgoraIntegrationEnabled}
            loading={this.props.loadingSync === 'ahgoraUsers'}
            icon='users' />

          <Button onClick={() => this.syncAhgoraClock()} 
            type='button' 
            content='Sincronizar Ponto'
            disabled={!settings.ahgoraIntegrationEnabled}
            loading={this.props.loadingSync === 'ahgoraClock'}
            icon='clock' />            

          <h3>Integração Maxis ForPonto</h3>
          <Form.Input>
            <Radio toggle checked={settings.forPontoIntegrationEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("forPontoIntegrationEnabled", data.checked)} />
          </Form.Input>

          <Form.Input disabled={!settings.forPontoIntegrationEnabled} error={errors.forPontoConnectionString} label='Connection String Banco de Dados' value={settings.forPontoConnectionString} name='forPontoConnectionString' type='text' onChange={(e, data) => this.handleChange("forPontoConnectionString", data.value)} />
          { errors.forPontoConnectionString && <Label color='red'>{errors.forPontoConnectionString}</Label>}

          <Form.Input disabled={!settings.forPontoIntegrationEnabled} error={errors.forPontoTableName} label='Tabela Registro de Ponto' value={settings.forPontoTableName} name='forPontoTableName' type='text' onChange={(e, data) => this.handleChange("forPontoTableName", data.value)} />
          { errors.forPontoTableName && <Label color='red'>{errors.forPontoTableName}</Label>}
          
          <Button onClick={() => this.testForPontoConnection()} 
            type='button' 
            content='Testar Conexão'
            disabled={!settings.forPontoIntegrationEnabled}
            loading={this.props.loadingSync === 'forPontoTest'}
            icon='database' />

          <Button onClick={() => this.syncForPontoUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.forPontoIntegrationEnabled}
            loading={this.props.loadingSync === 'forPontoUsers'}
            icon='users' />

          <Button onClick={() => this.syncForPontoClock()} 
            type='button' 
            content='Sincronizar Ponto'
            disabled={!settings.forPontoIntegrationEnabled}
            loading={this.props.loadingSync === 'forPontoClock'}
            icon='clock' />

          <h3>Integração APData</h3>
          <Form.Input>
            <Radio toggle checked={settings.apDataIntegrationEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("apDataIntegrationEnabled", data.checked)} />
          </Form.Input>

          <Form.Field required>
            <label>Modo Integração</label>
            <Dropdown
              disabled={!settings.apDataIntegrationEnabled} 
              placeholder='Selecione'
              fluid
              selection
              onChange={(e, data) => this.handleChange("apDataWebServiceMode", data.value)}
              options={webServiceModeOptions}
              value={settings.apDataWebServiceMode}
            />
            { errors.apDataWebServiceMode && <Label basic pointing  color='red'>{errors.apDataWebServiceMode}</Label>}
          </Form.Field>

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataTokenUrl} label='URL Token' value={settings.apDataTokenUrl} name='apDataTokenUrl' type='text' onChange={(e, data) => this.handleChange("apDataTokenUrl", data.value)} />
          { errors.apDataTokenUrl && <Label color='red'>{errors.apDataTokenUrl}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataGrantType} label='Grant Type' value={settings.apDataGrantType} name='apDataGrantType' type='text' onChange={(e, data) => this.handleChange("apDataGrantType", data.value)} />
          { errors.apDataGrantType && <Label color='red'>{errors.apDataGrantType}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataBaseUrl} label='URL Query' value={settings.apDataBaseUrl} name='apDataBaseUrl' type='text' onChange={(e, data) => this.handleChange("apDataBaseUrl", data.value)} />
          { errors.apDataBaseUrl && <Label color='red'>{errors.apDataBaseUrl}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataDateFormat} label='Formato Data' value={settings.apDataDateFormat} name='apDataDateFormat' type='text' onChange={(e, data) => this.handleChange("apDataDateFormat", data.value)} />
          { errors.apDataDateFormat && <Label color='red'>{errors.apDataDateFormat}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataUsername} label='Username' value={settings.apDataUsername} name='apDataUsername' type='text' onChange={(e, data) => this.handleChange("apDataUsername", data.value)} />
          { errors.apDataUsername && <Label color='red'>{errors.apDataUsername}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataPassword} label='Senha' value={settings.apDataPassword} name='apDataPassword' type='password' onChange={(e, data) => this.handleChange("apDataPassword", data.value)} />
          { errors.apDataPassword && <Label color='red'>{errors.apDataPassword}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataInitialClockId} label='ID Inicial Registro de Ponto (deixar 0 para todos)' value={settings.apDataInitialClockId} name='apDataInitialClockId' type='number' onChange={(e, data) => this.handleChange("apDataInitialClockId", data.value)} />
          { errors.apDataInitialClockId && <Label color='red'>{errors.apDataInitialClockId}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataToleranceEntry} label='Tolerância Entrada (minutos)' value={settings.apDataToleranceEntry} name='apDataToleranceEntry' type='number' onChange={(e, data) => this.handleChange("apDataToleranceEntry", data.value)} />
          { errors.apDataToleranceEntry && <Label color='red'>{errors.apDataToleranceEntry}</Label>}
        
          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataToleranceExit} label='Tolerância Saída (minutos)' value={settings.apDataToleranceExit} name='apDataToleranceExit' type='number' onChange={(e, data) => this.handleChange("apDataToleranceExit", data.value)} />
          { errors.apDataToleranceExit && <Label color='red'>{errors.apDataToleranceExit}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataPassword} label='ID Query Usuários' value={settings.apDataQueryIdUser} name='apDataQueryIdUser' type='text' onChange={(e, data) => this.handleChange("apDataQueryIdUser", data.value)} />
          { errors.apDataQueryIdUser && <Label color='red'>{errors.apDataQueryIdUser}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataQueryIdClock} label='ID Query Ponto' value={settings.apDataQueryIdClock} name='apDataQueryIdClock' type='text' onChange={(e, data) => this.handleChange("apDataQueryIdClock", data.value)} />
          { errors.apDataQueryIdClock && <Label color='red'>{errors.apDataQueryIdClock}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataSyncClockIntervalMinutes} label='Intervalo Busca Registros de Ponto (minutos)' value={settings.apDataSyncClockIntervalMinutes} name='apDataSyncClockIntervalMinutes' type='number' onChange={(e, data) => this.handleChange("apDataSyncClockIntervalMinutes", data.value)} />
          { errors.apDataSyncClockIntervalMinutes && <Label color='red'>{errors.apDataSyncClockIntervalMinutes}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataVaultServerUrl} label='Vault Server URL' value={settings.apDataVaultServerUrl} name='apDataVaultServerUrl' type='text' onChange={(e, data) => this.handleChange("apDataVaultServerUrl", data.value)} />
          { errors.apDataVaultServerUrl && <Label color='red'>{errors.apDataVaultServerUrl}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataVaultRuleName} label='Vault Rule Name' value={settings.apDataVaultRuleName} name='apDataVaultRuleName' type='text' onChange={(e, data) => this.handleChange("apDataVaultRuleName", data.value)} />
          { errors.apDataVaultRuleName && <Label color='red'>{errors.apDataVaultRuleName}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataVaultRuleKey} label='Vault Rule Key' value={settings.apDataVaultRuleKey} name='apDataVaultRuleKey' type='text' onChange={(e, data) => this.handleChange("apDataVaultRuleKey", data.value)} />
          { errors.apDataVaultRuleKey && <Label color='red'>{errors.apDataVaultRuleKey}</Label>}

          <Form.Input disabled={!settings.apDataIntegrationEnabled} error={errors.apDataVaultSecretId} label='Vault Secret ID' value={settings.apDataVaultSecretId} name='apDataVaultSecretId' type='text' onChange={(e, data) => this.handleChange("apDataVaultSecretId", data.value)} />
          { errors.apDataVaultSecretId && <Label color='red'>{errors.apDataVaultSecretId}</Label>}
          <Form.Input>
            <Radio toggle checked={settings.apDataDisablePaginate} label='Desabilitar Paginação' onChange={(e, data) => this.handleChange("apDataDisablePaginate", data.checked)} />
          </Form.Input>

          <Button onClick={() => this.syncApDataUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.apDataIntegrationEnabled}
            loading={this.props.loadingSync === 'apDataUsers'}
            icon='users' />

          <Button onClick={() => this.syncApDataClock()} 
            type='button' 
            content='Sincronizar Ponto'
            disabled={!settings.apDataIntegrationEnabled}
            loading={this.props.loadingSync === 'apDataClock'}
            icon='clock' />     

          <h3>Integração Sinergy</h3>
          <Form.Input>
            <Radio toggle checked={settings.sinergyIntegrationEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("sinergyIntegrationEnabled", data.checked)} />
          </Form.Input>

          <Form.Input disabled={!settings.sinergyIntegrationEnabled} error={errors.sinergyKey} label='Chave' value={settings.sinergyKey} name='sinergyKey' type='text' onChange={(e, data) => this.handleChange("sinergyKey", data.value)} />
          { errors.sinergyKey && <Label color='red'>{errors.sinergyKey}</Label>}

          <Form.Input disabled={!settings.sinergyIntegrationEnabled} error={errors.sinergyUsername} label='Username' value={settings.sinergyUsername} name='sinergyUsername' type='text' onChange={(e, data) => this.handleChange("sinergyUsername", data.value)} />
          { errors.sinergyUsername && <Label color='red'>{errors.sinergyUsername}</Label>}

          <Form.Input disabled={!settings.sinergyIntegrationEnabled} error={errors.sinergyPassword} label='Senha' value={settings.sinergyPassword} name='sinergyPassword' type='password' onChange={(e, data) => this.handleChange("sinergyPassword", data.value)} />
          { errors.sinergyPassword && <Label color='red'>{errors.sinergyPassword}</Label>}

          <Form.Input disabled={!settings.sinergyIntegrationEnabled} error={errors.sinergyToleranceEntry} label='Tolerância Antes Horário Entrada' value={settings.sinergyToleranceEntry} name='sinergyToleranceEntry' type='number' onChange={(e, data) => this.handleChange("sinergyToleranceEntry", data.value)} />
          { errors.sinergyToleranceEntry && <Label color='red'>{errors.sinergyToleranceStart}</Label>}

          <Form.Input disabled={!settings.sinergyIntegrationEnabled} error={errors.sinergyToleranceExit} label='Tolerância Após Horário Entrada (minutos)' value={settings.sinergyToleranceExit} name='sinergyToleranceExit' type='number' onChange={(e, data) => this.handleChange("sinergyToleranceExit", data.value)} />
          { errors.sinergyToleranceExit && <Label color='red'>{errors.sinergyToleranceExit}</Label>}

          <Form.Input>
            <Radio toggle disabled={!settings.sinergyIntegrationEnabled} checked={settings.sinergyBlockAwayUsers} label='Bloquear Usuários Afastados/Ferias' onChange={(e, data) => this.handleChange("sinergyBlockAwayUsers", data.checked)} />
          </Form.Input>

          <Button onClick={() => this.syncSinergyUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.sinergyIntegrationEnabled}
            loading={this.props.loadingSync === 'sinergyUsers'}
            icon='users' />

          <Button onClick={() => this.syncSinergyClock()} 
            type='button' 
            content='Sincronizar Ponto'
            disabled={!settings.sinergyIntegrationEnabled}
            loading={this.props.loadingSync === 'sinergyClock'}
            icon='clock' />     

          <h3>Integração PontoTel</h3>
          <Form.Input>
            <Radio toggle checked={settings.pontoTelIntegrationEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("pontoTelIntegrationEnabled", data.checked)} />
          </Form.Input>

          <Form.Input disabled={!settings.pontoTelIntegrationEnabled} error={errors.pontoTelBaseUrl} label='URL Base' value={settings.pontoTelBaseUrl} name='pontoTelBaseUrl' type='text' onChange={(e, data) => this.handleChange("pontoTelBaseUrl", data.value)} />
          { errors.pontoTelBaseUrl && <Label color='red'>{errors.pontoTelBaseUrl}</Label>}

          <Form.Input disabled={!settings.pontoTelIntegrationEnabled} error={errors.pontoTelUsername} label='Username' value={settings.pontoTelUsername} name='pontoTelUsername' type='text' onChange={(e, data) => this.handleChange("pontoTelUsername", data.value)} />
          { errors.pontoTelUsername && <Label color='red'>{errors.pontoTelUsername}</Label>}

          <Form.Input disabled={!settings.pontoTelIntegrationEnabled} error={errors.pontoTelPassword} label='Senha' value={settings.pontoTelPassword} name='pontoTelPassword' type='password' onChange={(e, data) => this.handleChange("pontoTelPassword", data.value)} />
          { errors.pontoTelPassword && <Label color='red'>{errors.pontoTelPassword}</Label>}

          <Form.Input disabled={!settings.pontoTelIntegrationEnabled} error={errors.pontoTelToleranceEntry} label='Tolerância Antes Horário Entrada' value={settings.pontoTelToleranceEntry} name='pontoTelToleranceEntry' type='number' onChange={(e, data) => this.handleChange("pontoTelToleranceEntry", data.value)} />
          { errors.pontoTelToleranceEntry && <Label color='red'>{errors.pontoTelToleranceStart}</Label>}

          <Form.Input disabled={!settings.pontoTelIntegrationEnabled} error={errors.pontoTelToleranceExit} label='Tolerância Após Horário Entrada (minutos)' value={settings.pontoTelToleranceExit} name='pontoTelToleranceExit' type='number' onChange={(e, data) => this.handleChange("pontoTelToleranceExit", data.value)} />
          { errors.pontoTelToleranceExit && <Label color='red'>{errors.pontoTelToleranceExit}</Label>}

          <Form.Input>
            <Radio toggle disabled={!settings.pontoTelIntegrationEnabled} checked={settings.pontoTelBlockAwayUsers} label='Bloquear Usuários Afastados/Ferias' onChange={(e, data) => this.handleChange("pontoTelBlockAwayUsers", data.checked)} />
          </Form.Input>

          <Button onClick={() => this.syncPontoTelUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.pontoTelIntegrationEnabled}
            loading={this.props.loadingSync === 'pontoTelUsers'}
            icon='users' />

          <Button onClick={() => this.syncPontoTelClock()} 
            type='button' 
            content='Sincronizar Ponto'
            disabled={!settings.pontoTelIntegrationEnabled}
            loading={this.props.loadingSync === 'pontoTelClock'}
            icon='clock' />     

          <h3>Integração Norber</h3>
          <Form.Input>
            <Radio toggle checked={settings.norberIntegrationEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("norberIntegrationEnabled", data.checked)} />
          </Form.Input>

          <Form.Input disabled={!settings.norberIntegrationEnabled} error={errors.norberBaseUrl} label='URL Base' value={settings.norberBaseUrl} name='norberBaseUrl' type='text' onChange={(e, data) => this.handleChange("norberBaseUrl", data.value)} />
          { errors.norberBaseUrl && <Label color='red'>{errors.norberBaseUrl}</Label>}

          <Form.Input disabled={!settings.norberIntegrationEnabled} error={errors.norberUsername} label='Usuário Integração' value={settings.norberUsername} name='norberUsername' type='text' onChange={(e, data) => this.handleChange("norberUsername", data.value)} />
          { errors.norberUsername && <Label color='red'>{errors.norberUsername}</Label>}

          <Form.Input disabled={!settings.norberIntegrationEnabled} error={errors.norberPassword} label='Senha Integração' value={settings.norberPassword} name='norberPassword' type='password' onChange={(e, data) => this.handleChange("norberPassword", data.value)} />
          { errors.norberPassword && <Label color='red'>{errors.norberPassword}</Label>}

          <Button onClick={() => this.syncNorberUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.norberIntegrationEnabled}
            loading={this.props.loadingSync === 'norberUsers'}
            icon='users' />                

          <h3>Integração Tivit</h3>
          <Form.Input>
            <Radio toggle checked={settings.tivitIntegrationEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("tivitIntegrationEnabled", data.checked)} />
          </Form.Input>

          <Form.Input disabled={!settings.tivitIntegrationEnabled} error={errors.tivitTenantId} label='Tenant ID' value={settings.tivitTenantId} name='tivitTenantId' type='text' onChange={(e, data) => this.handleChange("tivitTenantId", data.value)} />
          { errors.tivitTenantId && <Label color='red'>{errors.tivitTenantId}</Label>}

          <Form.Input disabled={!settings.tivitIntegrationEnabled} error={errors.tivitClientId} label='Client ID' value={settings.tivitClientId} name='tivitClientId' type='text' onChange={(e, data) => this.handleChange("tivitClientId", data.value)} />
          { errors.tivitClientId && <Label color='red'>{errors.tivitClientId}</Label>}

          <Form.Input disabled={!settings.tivitIntegrationEnabled} error={errors.tivitClientSecret} label='Client Secret' value={settings.tivitClientSecret} name='tivitClientSecret' type='text' onChange={(e, data) => this.handleChange("tivitClientSecret", data.value)} />
          { errors.tivitClientSecret && <Label color='red'>{errors.tivitClientSecret}</Label>}

          <Form.Input disabled={!settings.tivitIntegrationEnabled} error={errors.tivitScope} label='Scope' value={settings.tivitScope} name='tivitScope' type='text' onChange={(e, data) => this.handleChange("tivitScope", data.value)} />
          { errors.tivitScope && <Label color='red'>{errors.tivitScope}</Label>}

          <Form.Input disabled={!settings.tivitIntegrationEnabled} error={errors.tivitApiBaseUrl} label='URL Base API' value={settings.tivitApiBaseUrl} name='tivitApiBaseUrl' type='text' onChange={(e, data) => this.handleChange("tivitApiBaseUrl", data.value)} />
          { errors.tivitApiBaseUrl && <Label color='red'>{errors.tivitApiBaseUrl}</Label>}

          <Button onClick={() => this.syncTivitUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.tivitIntegrationEnabled}
            loading={this.props.loadingSync === 'tivitUsers'}
            icon='users' />

          <Button onClick={() => this.syncTivitClock()} 
            type='button' 
            content='Sincronizar Ponto'
            disabled={!settings.tivitIntegrationEnabled}
            loading={this.props.loadingSync === 'tivitClock'}
            icon='clock' />        

          <h3>Integração BEM</h3>
          <Form.Input>
            <Radio toggle checked={settings.bemIntegrationEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("bemIntegrationEnabled", data.checked)} />
          </Form.Input>

          <Form.Input disabled={!settings.bemIntegrationEnabled} error={errors.bemBaseUrl} label='URL Base' value={settings.bemBaseUrl} name='bemBaseUrl' type='text' onChange={(e, data) => this.handleChange("bemBaseUrl", data.value)} />
          { errors.bemBaseUrl && <Label color='red'>{errors.bemBaseUrl}</Label>}

          <Form.Input disabled={!settings.bemIntegrationEnabled} error={errors.bemUsername} label='Username' value={settings.bemUsername} name='bemUsername' type='text' onChange={(e, data) => this.handleChange("bemUsername", data.value)} />
          { errors.bemUsername && <Label color='red'>{errors.bemUsername}</Label>}

          <Form.Input disabled={!settings.bemIntegrationEnabled} error={errors.bemPassword} label='Senha' value={settings.bemPassword} name='bemPassword' type='password' onChange={(e, data) => this.handleChange("bemPassword", data.value)} />
          { errors.bemPassword && <Label color='red'>{errors.bemPassword}</Label>}

          <Form.Input disabled={!settings.bemIntegrationEnabled} error={errors.bemSeniorConnectionString} label='Connection String Senior' value={settings.bemSeniorConnectionString} name='bemSeniorConnectionString' type='text' onChange={(e, data) => this.handleChange("bemSeniorConnectionString", data.value)} />
          { errors.bemSeniorConnectionString && <Label color='red'>{errors.bemSeniorConnectionString}</Label>}

          <Form.Input disabled={!settings.bemIntegrationEnabled} error={errors.bemToleranceStart} label='Tolerância Entrada (minutos)' value={settings.bemToleranceStart} name='bemToleranceStart' type='number' onChange={(e, data) => this.handleChange("bemToleranceStart", data.value)} />
          { errors.bemToleranceStart && <Label color='red'>{errors.bemToleranceStart}</Label>}
        
          <Form.Input disabled={!settings.bemIntegrationEnabled} error={errors.bemToleranceEnd} label='Tolerância Saída (minutos)' value={settings.bemToleranceEnd} name='bemToleranceEnd' type='number' onChange={(e, data) => this.handleChange("bemToleranceEnd", data.value)} />
          { errors.bemToleranceEnd && <Label color='red'>{errors.bemToleranceEnd}</Label>}

          <Form.Input disabled={!settings.bemIntegrationEnabled} error={errors.bemLunchMinutes} label='Tempo Almoço (minutos)' value={settings.bemLunchMinutes} name='bemLunchMinutes' type='number' onChange={(e, data) => this.handleChange("bemLunchMinutes", data.value)} />
          { errors.bemLunchMinutes && <Label color='red'>{errors.bemLunchMinutes}</Label>}

          <Button onClick={() => this.syncBemUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.bemIntegrationEnabled}
            loading={this.props.loadingSync === 'bemUsers'}
            icon='users' />

          <Button onClick={() => this.syncBemClock()} 
            type='button' 
            content='Sincronizar Ponto'
            disabled={!settings.bemIntegrationEnabled}
            loading={this.props.loadingSync === 'bemClock'}
            icon='clock' />        

          <h3>Integração FolhaCerta</h3>
          <Form.Input>
            <Radio toggle checked={settings.folhaCertaIntegrationEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("folhaCertaIntegrationEnabled", data.checked)} />
          </Form.Input>

          <Form.Input disabled={!settings.folhaCertaIntegrationEnabled} error={errors.folhaCertaUrl} label='URL Base' value={settings.folhaCertaUrl} name='folhaCertaUrl' type='text' onChange={(e, data) => this.handleChange("folhaCertaUrl", data.value)} />
          { errors.folhaCertaUrl && <Label color='red'>{errors.folhaCertaUrl}</Label>}

          <Form.Input disabled={!settings.folhaCertaIntegrationEnabled} error={errors.folhaCertaToken} label='Token' value={settings.folhaCertaToken} name='folhaCertaToken' type='text' onChange={(e, data) => this.handleChange("folhaCertaToken", data.value)} />
          { errors.folhaCertaToken && <Label color='red'>{errors.folhaCertaToken}</Label>}

          <Form.Input disabled={!settings.folhaCertaIntegrationEnabled} error={errors.folhaCertaUrlSchedule} label='URL Base Escalas' value={settings.folhaCertaUrlSchedule} name='folhaCertaUrlSchedule' type='text' onChange={(e, data) => this.handleChange("folhaCertaUrlSchedule", data.value)} />
          { errors.folhaCertaUrlSchedule && <Label color='red'>{errors.folhaCertaUrlSchedule}</Label>}

          <Form.Input disabled={!settings.folhaCertaIntegrationEnabled} error={errors.folhaCertaTokenSchedule} label='Token Escalas' value={settings.folhaCertaTokenSchedule} name='folhaCertaTokenSchedule' type='text' onChange={(e, data) => this.handleChange("folhaCertaTokenSchedule", data.value)} />
          { errors.folhaCertaTokenSchedule && <Label color='red'>{errors.folhaCertaTokenSchedule}</Label>}

          <Form.Input disabled={!settings.folhaCertaIntegrationEnabled} error={errors.folhaCertaManagerIgnoreIds} label='IDs Gestores a ignorar (separados por ,)' value={settings.folhaCertaManagerIgnoreIds} name='folhaCertaManagerIgnoreIds' type='text' onChange={(e, data) => this.handleChange("folhaCertaManagerIgnoreIds", data.value)} />
          { errors.folhaCertaManagerIgnoreIds && <Label color='red'>{errors.folhaCertaManagerIgnoreIds}</Label>}

          <Button onClick={() => this.syncFolhaCertaUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.folhaCertaIntegrationEnabled}
            loading={this.props.loadingSync === 'folhaCertaUsers'}
            icon='users' />

          <Button onClick={() => this.syncFolhaCertaClock()} 
            type='button' 
            content='Sincronizar Ponto'
            disabled={!settings.folhaCertaIntegrationEnabled}
            loading={this.props.loadingSync === 'folhaCertaClock'}
            icon='clock' />        

          <h3>Integração Senior</h3>
          <Form.Input>
            <Radio toggle checked={settings.seniorIntegrationEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("seniorIntegrationEnabled", data.checked)} />
          </Form.Input>

          <Form.Input disabled={!settings.seniorIntegrationEnabled} error={errors.seniorUrl} label='URL Base' value={settings.seniorUrl} name='seniorUrl' type='text' onChange={(e, data) => this.handleChange("seniorUrl", data.value)} />
          { errors.seniorUrl && <Label color='red'>{errors.seniorUrl}</Label>}

          <Form.Input disabled={!settings.seniorIntegrationEnabled} error={errors.seniorToken} label='Token' value={settings.seniorToken} name='seniorToken' type='text' onChange={(e, data) => this.handleChange("seniorToken", data.value)} />
          { errors.seniorToken && <Label color='red'>{errors.seniorToken}</Label>}

          <Button onClick={() => this.syncSeniorUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.seniorIntegrationEnabled}
            loading={this.props.loadingSync === 'seniorUsers'}
            icon='users' />
          
          
          <h3>Integração ADP</h3>
          <Form.Input>
            <Radio toggle checked={settings.adpIntegrationEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("adpIntegrationEnabled", data.checked)} />
          </Form.Input>

          <Form.Input disabled={!settings.adpIntegrationEnabled} error={errors.adpDirectoryPath} label='Caminho Arquivo Integração Usuários' value={settings.adpDirectoryPath} name='adpDirectoryPath' type='text' onChange={(e, data) => this.handleChange("adpDirectoryPath", data.value)} />
          { errors.adpDirectoryPath && <Label color='red'>{errors.adpDirectoryPath}</Label>}

          <Form.Input disabled={!settings.adpIntegrationEnabled} error={errors.adpDirectoryAbsencePath} label='Caminho Arquivo Integração Ausências' value={settings.adpDirectoryAbsencePath} name='adpDirectoryAbsencePath' type='text' onChange={(e, data) => this.handleChange("adpDirectoryAbsencePath", data.value)} />
          { errors.adpDirectoryAbsencePath && <Label color='red'>{errors.adpDirectoryAbsencePath}</Label>}

          <Form.Input disabled={!settings.adpIntegrationEnabled} error={errors.adpDirectoryClockPath} label='Caminho Arquivo Integração Registros de Ponto' value={settings.adpDirectoryClockPath} name='adpDirectoryClockPath' type='text' onChange={(e, data) => this.handleChange("adpDirectoryClockPath", data.value)} />
          { errors.adpDirectoryClockPath && <Label color='red'>{errors.adpDirectoryClockPath}</Label>}

          <Form.Input disabled={!settings.adpIntegrationEnabled} error={errors.adpRestrictDomains} label='Restringir Usuários por Domínio E-Mail (separados por ,)' value={settings.adpRestrictDomains} name='adpRestrictDomains' type='text' onChange={(e, data) => this.handleChange("adpRestrictDomains", data.value)} />
          { errors.adpRestrictDomains && <Label color='red'>{errors.adpRestrictDomains}</Label>}

          <Form.Input disabled={!settings.adpIntegrationEnabled} error={errors.adpDefaultStartTime} label='Horário de Início de Jornada Padrão' value={settings.adpDefaultStartTime} name='adpDefaultStartTime' type='text' onChange={(e, data) => this.handleChange("adpDefaultStartTime", data.value)} />
          { errors.adpDefaultStartTime && <Label color='red'>{errors.adpDefaultStartTime}</Label>}          

          <Form.Input disabled={!settings.adpIntegrationEnabled} error={errors.adpToleranceStart} label='Tolerância Entrada (minutos)' value={settings.adpToleranceStart} name='adpToleranceStart' type='number' onChange={(e, data) => this.handleChange("adpToleranceStart", data.value)} />
          { errors.adpToleranceStart && <Label color='red'>{errors.adpToleranceStart}</Label>}
        
          <Form.Input disabled={!settings.adpIntegrationEnabled} error={errors.adpToleranceEnd} label='Tolerância Saída (minutos)' value={settings.adpToleranceEnd} name='adpToleranceEnd' type='number' onChange={(e, data) => this.handleChange("adpToleranceEnd", data.value)} />
          { errors.adpToleranceEnd && <Label color='red'>{errors.adpToleranceEnd}</Label>}

          <Button onClick={() => this.syncAdpUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.adpIntegrationEnabled}
            loading={this.props.loadingSync === 'adpUsers'}
            icon='users' />

            <Button onClick={() => this.syncAdpClock()} 
            type='button' 
            content='Sincronizar Ponto'
            disabled={!settings.adpIntegrationEnabled}
            loading={this.props.loadingSync === 'adpClock'}
            icon='clock' />
          
          <h3>Integração Database</h3>
          <Form.Input>
            <Radio toggle checked={settings.databaseIntegrationEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("databaseIntegrationEnabled", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio disabled={!settings.databaseIntegrationEnabled} toggle checked={settings.databaseAutoCreateUser} label='Criar Usuários Automaticamente' onChange={(e, data) => this.handleChange("databaseAutoCreateUser", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio disabled={!settings.databaseIntegrationEnabled} toggle checked={settings.databaseSyncPersonalData} label='Sincronizar Dados Pessoais' onChange={(e, data) => this.handleChange("databaseSyncPersonalData", data.checked)} />
          </Form.Input>

          <Form.Input disabled={!settings.databaseIntegrationEnabled} error={errors.databaseConnectionString} label='Connection String Banco de Dados (deixe em branco para usar a mesma do Addon)' value={settings.databaseConnectionString} name='databaseConnectionString' type='text' onChange={(e, data) => this.handleChange("databaseConnectionString", data.value)} />
          { errors.databaseConnectionString && <Label color='red'>{errors.databaseConnectionString}</Label>}

          <Form.Input disabled={!settings.databaseIntegrationEnabled} error={errors.databaseTableClock} label='Tabela Registro de Ponto' value={settings.databaseTableClock} name='databaseTableClock' type='text' onChange={(e, data) => this.handleChange("databaseTableClock", data.value)} />
          { errors.databaseTableClock && <Label color='red'>{errors.databaseTableClock}</Label>}

          <Form.Input disabled={!settings.databaseIntegrationEnabled} error={errors.databaseTableUser} label='Tabela Usuários' value={settings.databaseTableUser} name='databaseTableUser' type='text' onChange={(e, data) => this.handleChange("databaseTableUser", data.value)} />
          { errors.databaseTableUser && <Label color='red'>{errors.databaseTableUser}</Label>}

          <Form.Input disabled={!settings.databaseIntegrationEnabled} error={errors.databaseSyncIds} label='IDs Usuários a sincronizar (separados por ,)' value={settings.databaseSyncIds} name='databaseSyncIds' type='text' onChange={(e, data) => this.handleChange("databaseSyncIds", data.value)} />
          { errors.databaseSyncIds && <Label color='red'>{errors.databaseSyncIds}</Label>}

          <Form.Input disabled={!settings.databaseIntegrationEnabled} error={errors.databaseToleranceEntry} label='Tolerância Entrada (minutos)' value={settings.databaseToleranceEntry} name='databaseToleranceEntry' type='number' onChange={(e, data) => this.handleChange("databaseToleranceEntry", data.value)} />
          { errors.databaseToleranceEntry && <Label color='red'>{errors.databaseToleranceEntry}</Label>}
        
          <Form.Input disabled={!settings.databaseIntegrationEnabled} error={errors.databaseToleranceExit} label='Tolerância Saída (minutos)' value={settings.databaseToleranceExit} name='databaseToleranceExit' type='number' onChange={(e, data) => this.handleChange("databaseToleranceExit", data.value)} />
          { errors.databaseToleranceExit && <Label color='red'>{errors.databaseToleranceExit}</Label>}

          <Form.Input disabled={!settings.databaseIntegrationEnabled} error={errors.databaseAdditionalTimeSaturday} label='Tempo Adicional aos Sábados (minutos)' value={settings.databaseAdditionalTimeSaturday} name='databaseAdditionalTimeSaturday' type='number' onChange={(e, data) => this.handleChange("databaseAdditionalTimeSaturday", data.value)} />
          { errors.databaseAdditionalTimeSaturday && <Label color='red'>{errors.databaseAdditionalTimeSaturday}</Label>}          
          
          <Button onClick={() => this.testDatabaseConnection()} 
            type='button' 
            content='Testar Conexão'
            disabled={!settings.databaseIntegrationEnabled}
            loading={this.props.loadingSync === 'databaseTest'}
            icon='database' />

          <Button onClick={() => this.syncDatabaseUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.databaseIntegrationEnabled}
            loading={this.props.loadingSync === 'databaseUsers'}
            icon='users' />

          <Button onClick={() => this.syncDatabaseClock()} 
            type='button' 
            content='Sincronizar Ponto'
            disabled={!settings.databaseIntegrationEnabled}
            loading={this.props.loadingSync === 'databaseClock'}
            icon='clock' />
          
          
          <h3>Integração AzureAD</h3>
          <Form.Input>
            <Radio toggle checked={settings.azureAdEnabled} label='Habilitar Integração' onChange={(e, data) => this.handleChange("azureAdEnabled", data.checked)} />
          </Form.Input>
          <p>
            Para habilitar a integração <a href="https://portal.azure.com/#blade/Microsoft_AAD_RegisteredApps/ApplicationsListBlade" target="_blank">crie e registre uma aplicação no Azure</a> e dê as seguintes permissões:
            <ul>
              <li>Application.Read.All</li>
              <li>User.ReadWrite.All</li>
              <li>Group.ReadWrite.All</li>
              <li>Policy.ReadWrite.ConditionalAccess </li>
            </ul>
          </p>

          <Form.Field required>
            <label>Usuários a Controlar</label>
            <Dropdown
              placeholder='Selecione'
              fluid
              selection
              disabled={!settings.azureAdEnabled}
              onChange={(e, data) => this.handleChange("azureAdBlockMode", data.value)}
              options={azureAdBlockModeOptions}
              value={settings.azureAdBlockMode}
            />
            { errors.protectedAccountMode && <Label basic pointing  color='red'>{errors.protectedAccountMode}</Label>}
          </Form.Field>

          <Form.Input>
            <Radio toggle checked={settings.azureAdStrictEntry} label='Controle Estrito de Entrada' onChange={(e, data) => this.handleChange("azureAdStrictEntry", data.checked)} />
          </Form.Input>

          <Form.Input>
            <Radio toggle checked={settings.azureAdRevokeSignIns} label='Expirar sessões do usuário ao bloquear' onChange={(e, data) => this.handleChange("azureAdRevokeSignIns", data.checked)} />
          </Form.Input>

          <Form.Input disabled={!settings.azureAdEnabled} error={errors.azureAdBlockMarginMinutes} label='Margem Desbloqueio (minutos)' value={settings.azureAdBlockMarginMinutes} name='azureAdBlockMarginMinutes' type='number' onChange={(e, data) => this.handleChange("azureAdBlockMarginMinutes", data.value)} />
          { errors.azureAdBlockMarginMinutes && <Label color='red'>{errors.azureAdBlockMarginMinutes}</Label>}

          <Form.Input disabled={!settings.azureAdEnabled} error={errors.azureAdTenantId} label='Tenant ID' value={settings.azureAdTenantId} name='azureAdTenantId' type='text' onChange={(e, data) => this.handleChange("azureAdTenantId", data.value)} />
          { errors.azureAdTenantId && <Label color='red'>{errors.azureAdTenantId}</Label>}

          <Form.Input disabled={!settings.azureAdEnabled} error={errors.azureAdClientId} label='Client ID' value={settings.azureAdClientId} name='azureAdClientId' type='text' onChange={(e, data) => this.handleChange("azureAdClientId", data.value)} />
          { errors.azureAdClientId && <Label color='red'>{errors.azureAdClientId}</Label>}

          <Form.Input disabled={!settings.azureAdEnabled} error={errors.azureAdClientSecret} label='Client Secret' value={settings.azureAdClientSecret} name='azureAdClientSecret' type='text' onChange={(e, data) => this.handleChange("azureAdClientSecret", data.value)} />
          { errors.azureAdClientSecret && <Label color='red'>{errors.azureAdClientSecret}</Label>}

          <Form.Input disabled={!settings.azureAdEnabled} error={errors.azureAdUserDomain} label='Domínio Azure AD' value={settings.azureAdUserDomain} name='azureAdUserDomain' type='text' onChange={(e, data) => this.handleChange("azureAdUserDomain", data.value)} />
          { errors.azureAdUserDomain && <Label color='red'>{errors.azureAdUserDomain}</Label>}

          <Button onClick={() => this.testAzureAdAuth()} 
            type='button' 
            content='Testar Autenticação'
            disabled={!settings.azureAdEnabled}
            loading={this.props.loadingSync === 'azureTest'}
            icon='lock' />    
          
          <Form.Input disabled={!settings.azureAdEnabled} error={errors.azureAdBlockPolicyId} label='ID Política Condicional de Bloqueio' value={settings.azureAdBlockPolicyId} name='azureAdBlockPolicyId' type='text' onChange={(e, data) => this.handleChange("azureAdBlockPolicyId", data.value)} />
          { errors.azureAdBlockPolicyId && <Label color='red'>{errors.azureAdBlockPolicyId}</Label>}

          <Form.Input disabled={!settings.azureAdEnabled} error={errors.azureAdBlockGroupId} label='ID Grupo Usuários Bloqueados' value={settings.azureAdBlockGroupId} name='azureAdBlockGroupId' type='text' onChange={(e, data) => this.handleChange("azureAdBlockGroupId", data.value)} />
          { errors.azureAdBlockGroupId && <Label color='red'>{errors.azureAdBlockGroupId}</Label>}

          <Button onClick={() => this.createAzureAdPolicyAndGroup()} 
            type='button' 
            content='Criar Grupo e Política'
            disabled={!settings.azureAdEnabled}
            loading={this.props.loadingSync === 'azurePolicy'}
            icon='add' />

          <Button onClick={() => this.syncAzureAdUsers()} 
            type='button' 
            content='Sincronizar Usuários'
            disabled={!settings.azureAdEnabled}
            loading={this.props.loadingSync === 'azureUsers'}
            icon='users' />          

          <h3>Integração Active Directory (BETA)</h3>
          <Form.Input>
            <Radio toggle checked={settings.activeDirectoryLogonHoursEnabled} label='Configurar Restrições de Horário AD' onChange={(e, data) => this.handleChange("activeDirectoryLogonHoursEnabled", data.checked)} />
          </Form.Input>

          <div style={{marginTop: '8px'}}>
            <Button primary type='submit'>Salvar</Button>
          </div>  
        </Form>
      </Fragment>
    );

    const tabLicense = (      
      settings.license && <Fragment>
          <h3>Informações da Licença</h3>
          <p><b>Registrado para:</b> {settings.license.Name}</p>
          <p><b>Código:</b> {settings.license.Key}</p>
          <p><b>Limite Usuários:</b> {settings.license.ActiveUserCount} / {settings.license.UserAccountMax}</p>
          <p><b>Emissão: </b> {moment(settings.license.StartDate).format('DD/MM/YYYY')}</p>
          <p><b>Validade: </b> {settings.license.EndDate ? moment(settings.license.EndDate).format('DD/MM/YYYY') : 'Perpétua'}</p>
          <h3>Atualizar Licença</h3>
          <Form.TextArea style={{width: "400px"}} onChange={(e, data) => this.handleChange("newLicense", data.value)} />          
          <Button onClick={() => this.updateLicense()}  type='button'>
            Atualizar
          </Button>
      </Fragment>
    );

    const panes = [
      { menuItem: 'Geral', render: () => tabSettings },
      { menuItem: 'Visual', render: () => tabVisual },
      { menuItem: 'Autenticação', render: () => tabOpenId },
      { menuItem: 'Integrações', render: () => tabIntegration },
      { menuItem: 'Importação', render: () => <ImportScreen></ImportScreen> },
      { menuItem: 'Webhooks', render: () => <WebhookIndexScreen></WebhookIndexScreen> },
      { menuItem: 'Agente', render: () => tabAgent },
      { menuItem: 'Licença', render: () => tabLicense },      
    ]    

    return <Fragment>
              <Header as='h1'>Configurações</Header>              
              <Tab panes={panes} />                      
           </Fragment>
  }
}

function mapStateToProps(state) {
  const { settings, users } = state;
  return {
    settings: settings.globalSettings,
    loading: settings.loading || false,
    loadingSync: settings.loadingSync || false,
    me: users.me || null,
  };
}

const connectedconnectedGlobalSettingsEditScreen = connect(mapStateToProps)(GlobalSettingsEditScreen);
export { connectedconnectedGlobalSettingsEditScreen as GlobalSettingsEditScreen };
